type Props = {
  quote: string;
  name: string;
  title?: string;
  photoUrl?: string;
};

export function TestimonialCard({ quote, name, title, photoUrl }: Props) {
  return (
    <div class="border-t border-gray-200 pt-6 first:border-t-0 first:pt-0">
      <p class="text-gray-600 text-sm italic leading-relaxed">&ldquo;{quote}&rdquo;</p>
      <div class="mt-3 flex items-center gap-3">
        {photoUrl && <img src={photoUrl} alt={name} class="w-10 h-10 rounded-full object-cover" />}
        <div>
          <p class="font-bold text-gray-900 text-sm">{name}</p>
          {title && <p class="text-gray-500 text-xs italic">{title}</p>}
        </div>
      </div>
    </div>
  );
}
